<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="warehouses"
    :title="`${$t('title.selectwarehouse')}`"
    idProperty="WarehouseId"
    nameProperty="WarehouseName"
    allSelectId="warehouseAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :modalId="modalId"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="WarehouseNumber"
    :defaultItems="defaultItems"
    viewName="WarehouseSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      warehouses: [],
      columns: [
        {
          name: "WarehouseNumber",
        },
        {
          name: "WarehouseName",
        },
      ],
      id: "warehouseSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      let newDTO = {};
      if (dTO) newDTO = dTO;
      if (this.$route.path.includes("stocktransfer")) {
        newDTO.WithoutFilter = true;
      }
      const vm = this;
      this.$api.warehouses.getPages(newDTO).then((data) => {
        vm.warehouses = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
